module.exports = __webpack_public_path__ + "img/cursor-03.4ac40cbf.svg";